/* CED Header JS — IntersectionObserver for scrolled state */
(function () {
  function init() {
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;

    /* Sentinel pixel at top of page — exits viewport on first scroll */
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;height:1px;width:1px;pointer-events:none;';
    document.body.prepend(sentinel);

    new IntersectionObserver(function (entries) {
      wrapper.classList.toggle('ced-header-wrapper--scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
